<template>
  <main role="main" class="py-4">
    <b-container>
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("accountsSignDay") }}</h4>
        <div>
          <!-- <b-button variant="outline-secondary" @click="onClickReloadBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button> -->
        </div>
      </div>

      <b-form class="d-flex flex-row align-items-center mb-3" @submit.prevent="onClickSearchBtn">
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3"> {{ $t("fromDate") }}</div>
          <b-form-datepicker v-model="startDate" value-as-date required
                             :max="getMaxDate()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3">{{ $t("toDate") }}</div>
          <b-form-datepicker v-model="endDate" value-as-date required
                             no-flip hide-header
                             :min="getMinDate(startDate)"
                             :max="getMaxDate()"
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <b-button type="submit" variant="primary">{{ $t("apply") }}</b-button>
      </b-form>

      <b-table ref="table" :items="tableItemProvider" hover primary-key="id" :fields="tableFields"
               :busy="isLoading" show-empty
               :per-page="itemsPerPage" :current-page="currentPage">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        
      </b-table>
      <div class="d-flex flex-row align-items-center justify-content-between">
        <div></div>
        <!-- <b-button variant="link" :disabled="!totalItems || isExportingToExcel" @click="onClickExportToExcel">
          <b-icon-download class="mr-2"></b-icon-download> {{ $t("export") }}
        </b-button> -->
        <div class="d-flex flex-row align-items-center">
          <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">{{ $t("resultCount", { count: totalItems }) }}</div>
          <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems" :per-page="itemsPerPage"></b-pagination>
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections"></b-form-select>
        </div>
      </div>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Ref, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import moment from "moment";
  import BaseComponent from "@/components/BaseComponent";
  import {BvTableFieldArray} from "bootstrap-vue";
  import {BTable, BvTableCtxObject, BvTableProviderPromiseResult} from "bootstrap-vue/src/components/table";
  import * as reportService from "@/service/reportService";
  import * as areaService from "@/service/areaService";
import { formatDateRange } from '@/service/util';

  @Component
  export default class NewContractsDay extends BaseComponent {

    searchText = "";

    searchAreaId: number = null;
    searchAreaOptions = [];

    startDate: Date = null;
    endDate: Date = null;
    formErrorMsg = "";
    isLoading = false;

    @Ref("table") table: BTable;
    tableFields: BvTableFieldArray = [
    {
        key: "id",
        label: "ID",
        thClass: "text-nowrap",
      },
      {
        key: "customerCode",
        label: this.$t("customerIdShort").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "name",
        label: this.$t("customerNameShort").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      {
        key: "email",
        label: "Email",
        thClass: "text-nowrap",
      },
      {
        key: "phoneNumber",
        label: this.$t("phoneNumber").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "saleAreaName",
        label: this.$t("saleArea").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      {
        key: "subPlanName",
        label: this.$t("subscriptionPlan").toString(),
        thClass: "text-nowrap",
        tdClass: "text-break",
      },
      {
        key: "cusSubEndDate",
        formatter: this.formatter,
        label: this.$t("expDate").toString(),
        thClass: "text-nowrap",
      }
    ];

    isExportingToExcel = false;

    itemsPerPageSelections = [
      { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
      { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
      { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
      { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
    ];
    itemsPerPage = 20;
    currentPage = 1;
    totalItems = 0;


    mounted() {
      this.startDate = moment().subtract(0, "days").startOf("day").toDate();
      this.endDate = moment().endOf("day").toDate();
      this.fetchAreas();
    }

    formatter(value, key, index) {
      value = new Date(value);
      return value.getFullYear() >10 ? value.toLocaleDateString('en-GB') : null;
    }


    async fetchAreas() {
      try {
        const areas = await areaService.getAll();
        this.searchAreaOptions = areas.map(a => ({ value: a.id, text: a.name }));
        this.searchAreaOptions.unshift({ value: null, text: this.$t("all").toString()});

      } catch (e) {
        this.toastError(e);
      }
    }

    onClickReloadBtn() {
      this.searchText = "";
      this.startDate = moment().subtract(30, "days").startOf("day").toDate();
      this.endDate = moment().endOf("day").toDate();
      this.formErrorMsg = "";
      this.itemsPerPage = 20;
      this.currentPage = 1;
      this.totalItems = 0;

      this.table.refresh();
    }

    onClickSearchBtn() {
      this.table.refresh();
    }

    async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
      //sử dụng logic về ngày tháng giống với danh sách cuộc họp.
      const { fromDate, toDate } = formatDateRange(this.startDate, this.endDate);
    
      try {
        const customerListRes = await reportService.getCustomerSubListCount(
          this.startDate ? fromDate : null,
          this.endDate ? toDate : null,
          ctx.currentPage,
          this.itemsPerPage
        );

        this.totalItems = customerListRes.total;
        return customerListRes.data;

      } catch (e) {
        this.toastError(e);
        return [];
      }
    }


    async onClickExportToExcel() {
      try {
        this.isExportingToExcel = true;
        const customers = [];
   const { fromDate, toDate } = formatDateRange(this.startDate, this.endDate);
        while (true) {
          const pageSize = 500;
          const customerListRes = await reportService.getCustomerMeetingsCountDetails({
            fromDate: fromDate,
            toDate: toDate,
            page: 1,
            pageSize,
            q: this.searchText?.trim(),
            areaId: this.searchAreaId
          });
          const part: any[] = Array.isArray(customerListRes.data)? customerListRes.data : [];
          customers.push(...part);
          if (part.length < pageSize) break;
        }

        const sheetData = customers.map(it => [
          it.customerId,
          it.name,
          it.customerAddress,
          moment(it.fromDate).format("DD/MM/YYYY"),
          moment(it.toDate).format("DD/MM/YYYY"),
          it.meetingEnded,
          it.meetingInProgress,
          it.meetingPending,
          it.meetingCancelled
        ]);
        sheetData.unshift(["ID", "Tên KH", "Địa chỉ", "Từ ngày", "Đến ngày", "Đã thực hiện", "Đang diễn ra", "Đang chờ", "Đã hủy"]);

        const XLSX = await import("xlsx");

        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, sheet);
        XLSX.writeFile(workbook, "ThongKeChiTietSoLuongCuocHop.xlsx");

      } catch (e) {
        console.error(e);
        this.toastError(e);

      } finally {
        this.isExportingToExcel = false;
      }
    }

  }
</script>
